import { render } from "./FireSupportForm.vue?vue&type=template&id=86b168d2&scoped=true"
import script from "./FireSupportForm.vue?vue&type=script&lang=ts"
export * from "./FireSupportForm.vue?vue&type=script&lang=ts"

import "./FireSupportForm.vue?vue&type=style&index=0&id=86b168d2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-86b168d2"

export default script